import { render, staticRenderFns } from "./ConfirmDeleteModal.vue?vue&type=template&id=180a4d78"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=180a4d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports